import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { QualificationBreakdown } from "../telepro/TeleproQualificationCard";

// VAGUE 42 — vue admin : motifs de refus, leads chauds, injoignables.
export default function AdminQualificationStatsPanel() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/admin/telepro/qualification-stats?days=${days}`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [days]);

  return (
    <div className="space-y-4" data-testid="admin-qualification-panel">
      <div className="flex flex-wrap items-center gap-2">
        {[7, 30, 90].map((d) => (
          <button key={d} type="button" onClick={() => setDays(d)}
            className={`text-xs font-semibold border rounded-sm px-3 py-1.5 ${days === d ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border"}`}
            data-testid={`admin-qualif-days-${d}`}>{d} jours</button>
        ))}
      </div>
      {!data ? <div className="text-sm text-muted-foreground">Chargement…</div>
        : data.error ? <div className="text-sm text-secondary">Statistiques indisponibles.</div> : (
        <>
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-card border border-border rounded-sm p-3" data-testid="admin-unreachable-temp">
              <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Injoignables temporaires (60 j)</div>
              <div className="font-display text-2xl">{data.unreachable_temp}</div>
            </div>
            <div className="bg-card border border-border rounded-sm p-3" data-testid="admin-unreachable-final">
              <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">Injoignables définitifs</div>
              <div className="font-display text-2xl">{data.unreachable_final}</div>
            </div>
          </div>
          <div className="bg-card border border-border rounded-sm p-4">
            <div className="font-display text-base font-medium mb-3">Toute l&apos;équipe</div>
            <QualificationBreakdown data={data} testid="admin-qualif-all"/>
          </div>
          {data.per_telepro.map((t) => (
            <details key={t.code} className="bg-card border border-border rounded-sm p-4" data-testid={`admin-qualif-tp-${t.code}`}>
              <summary className="cursor-pointer text-sm font-semibold">
                {t.first_name || t.code} <span className="font-mono text-muted-foreground">({t.code})</span> · {t.refusals_total} refus
              </summary>
              <div className="mt-3"><QualificationBreakdown data={t} testid={`admin-qualif-${t.code}`}/></div>
            </details>
          ))}
        </>
      )}
    </div>
  );
}
